import {
  Button,
  Card,
  Divider,
  Grid,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  Typography,
  IconButton,
  Alert,
  Pagination,
  CardContent,
  TableContainer,
  TextField,
  Box
} from '@mui/material'

// import { makeStyles } from '@mui/material/styles'
import {
  Add as AddIcon,
  Delete,
  Edit as EditIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { businessCheck } from '../../utils/utils'
import ContactPersonDrawer from '../contact_person/contactperson/contactPersonDialog'
import VendorDrawer from '../customer/customer/customerDialog'
import VendorInfoDrawer from '../customer/customer/customerInfoDialog'
import _ from 'lodash'
import {
  ConfirmationDialog,
  SnackBarHideDuration,
  SnackBarTransition,
  StyledTableCell,
  StyledTableRow
} from '../../utils/ui_utils'
import {
  useCreateContactPerson,
  useSearchContactPerson
} from '../../modules/contactPerson/contactPersonHooks'
import {
  useCreateVendor,
  useUpdateVendor,
  useVendorFetch
} from '../../modules/vendor/vendorHooks'

function Vendor() {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [pagecount, setPageCount] = useState(0)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [vendorData, setVendorData] = useState(null)

  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [deleteConfirmationVisibility, setDeleteConfirmationVisibility] =
    useState(false)

  const [contactPersonInitialData, setContactPersonInitialData] = useState({
    first_name: '',
    last_name: '',
    mobile: '',
    email: '',
    telephone: '',
    comments: ''
  })
  const [contactPersonDrawerVisibility, setContactPersonDrawerVisibility] =
    useState(false)
  const [vendorDrawerMode, setVendorDrawerMode] = useState('new')
  const [vendorDrawerVisibility, setVendorDrawerVisibility] = useState(false)
  const [vendorInfoDrawerVisibility, setVendorInfoDrawerVisibility] =
    useState(false)
  const { searchContactPerson, searchContactPersonData } =
    useSearchContactPerson()
  const { fetchVendor, fetchVendorData, fetchVendorError, fetchVendorLoading } =
    useVendorFetch()
  const { createVendor } = useCreateVendor()
  const { updateVendor } = useUpdateVendor()
  const { createContactPerson } = useCreateContactPerson()

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const handlePageChange = async (event, value) => {
    setPage(value)
    let payload = {
      pageNumber: value,
      limit: limit
    }
    fetchVendor(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (value === '' || /^\d+$/.test(value)) {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const history = useNavigate()
  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit
    }
    fetchVendor(payload)
  }, [])

  useEffect(() => {
    if (fetchVendorData.data?.length > 0) {
      pageCount(fetchVendorData.total)
    }
  }, [fetchVendorData])

  if (fetchVendorError) return <p>Error!</p>
  if (fetchVendorLoading) return <p>Loading...</p>
  return (
    <>
      <Helmet title="Vendors" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9} md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Vendors
          </Typography>
        </Grid>
        <Grid item>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              setVendorDrawerVisibility(true)
              setVendorDrawerMode('new')
              setVendorData({
                name: '',
                address: '',
                mobile: '',
                email: '',
                gstn: '',
                city: '',
                pincode: '',
                state: '',
                country: '',
                contactperson: []
              })
            }}
          >
            Add Vendor
          </Button>
          <VendorDrawer
            visible={vendorDrawerVisibility}
            title={
              vendorDrawerMode == 'new' ? 'Create New Vendor' : 'Edit Vendor'
            }
            okText={vendorDrawerMode == 'new' ? 'Create' : 'Update'}
            contactPersonData={searchContactPersonData?.data}
            initialValues={vendorData}
            onContactPersonSearch={(value) => {
              if (value != '') searchContactPerson(value)
            }}
            onCancel={() => {
              setVendorDrawerVisibility(false)
            }}
            onSubmit={async (value) => {
              let values = _.cloneDeep(value)
              if (vendorDrawerMode == 'new') {
                let contact = []
                for (let i = 0; i < values.contactperson.length; i++) {
                  if (values.contactperson[i]?.business_id) {
                    delete values.contactperson[i].business_id
                  }
                  contact.push(BigInt(values.contactperson[i]?._id))
                }
                values.contactperson = contact
                await createVendor(values, (success, error) => {
                  if (error) {
                    setVendorDrawerVisibility(true)
                    toastMessage('Error Occurred', 'error')
                  } else {
                    setVendorDrawerVisibility(false)
                    let payload = {
                      pageNumber: page,
                      limit: limit
                    }
                    fetchVendor(payload)
                    toastMessage('Vendor created successfully ', 'success')
                  }
                })
              } else {
                values.id = BigInt(values._id)
                delete values._id
                delete values.business_id
                let contact = []
                for (let i = 0; i < values.contactperson.length; i++) {
                  if (values.contactperson[i]?.business_id) {
                    delete values.contactperson[i].business_id
                  }
                  contact.push(BigInt(values.contactperson[i]?._id))
                }
                delete values.contactperson
                values.contactperson = contact
                delete values.key
                await updateVendor(values, (success, error) => {
                  if (error) {
                    setVendorDrawerVisibility(true)
                    toastMessage('Error Occurred', 'error')
                  } else {
                    setVendorDrawerVisibility(false)
                    let payload = {
                      pageNumber: page,
                      limit: limit
                    }
                    fetchVendor(payload)
                    toastMessage('Vendor updated successfully ', 'success')
                  }
                })
              }
            }}
            onAddContactPersonClick={() => {
              setContactPersonDrawerVisibility(true)
            }}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      <Grid container spacing={10} sx={{ paddingTop: 5 }}>
        <Grid item md={8} lg={10}>
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <TableContainer component={Card}>
                <Table size="small">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Name</StyledTableCell>
                      <StyledTableCell align="left"> Mobile</StyledTableCell>
                      <StyledTableCell align="left"> GSTN</StyledTableCell>
                      <StyledTableCell align="left">Address</StyledTableCell>
                      <StyledTableCell align="left">City</StyledTableCell>
                      <StyledTableCell align="left">State</StyledTableCell>
                      <StyledTableCell align="left">Pincode</StyledTableCell>
                      <StyledTableCell align="center">Edit</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {fetchVendorData.data?.map((row, i) => (
                      <StyledTableRow key={i} hover>
                        <StyledTableCell component="th" scope="row">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row?.mobile}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.gstn}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.address}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.city}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.state}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.pincode}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setVendorDrawerVisibility(true)
                              setVendorDrawerMode('edit')
                              setVendorData(row)
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setVendorInfoDrawerVisibility(true)
                              setVendorData(row)
                            }}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            component="span"
                            onClick={() => {
                              setDeleteConfirmationVisibility(true)
                              setVendorData(row)
                            }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            {pagecount > 1 && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  p: 2,
                  backgroundColor: 'grey.50',
                  borderRadius: 1
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <Pagination
                    count={pagecount}
                    page={page}
                    color="secondary"
                    size="small"
                    boundaryCount={2}
                    siblingCount={0}
                    showFirstButton
                    showLastButton
                    onChange={handlePageChange}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        transition: 'all 0.2s ease-in-out'
                      }
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1.5,
                    backgroundColor: 'white',
                    p: 2,
                    borderRadius: 1,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                      boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                    }
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 500 }}
                  >
                    Jump to
                  </Typography>
                  <TextField
                    size="small"
                    value={goToPageInput}
                    onChange={handleGoToPageChange}
                    onKeyPress={handleGoToPageKeyPress}
                    placeholder="Page"
                    sx={{
                      width: '80px',
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        transition: 'all 0.2s ease-in-out',
                        '& fieldset': {
                          borderColor: 'grey.300',
                          borderWidth: '1px'
                        },
                        '&:hover fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '1.5px'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '2px',
                          boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                        }
                      },
                      '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        fontWeight: 500,
                        padding: '7px 8px',
                        height: '20px',
                        lineHeight: '20px'
                      }
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 400 }}
                  >
                    of {pagecount}
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleGoToPageSubmit}
                    disabled={
                      !goToPageInput ||
                      parseInt(goToPageInput, 10) < 1 ||
                      parseInt(goToPageInput, 10) > pagecount
                    }
                    sx={{
                      textTransform: 'none',
                      fontWeight: 500,
                      px: 2,
                      py: 0.75,
                      height: '34px',
                      lineHeight: 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                      },
                      '&:active': {
                        transform: 'translateY(0)'
                      }
                    }}
                  >
                    Go
                  </Button>
                </Box>
              </Box>
            )}
          </Card>
          <VendorInfoDrawer
            visible={vendorInfoDrawerVisibility}
            title={'Vendor Info'}
            cancelText={'Close'}
            onCancel={() => setVendorInfoDrawerVisibility(false)}
            initialValues={vendorData}
          />
          <ContactPersonDrawer
            initialValues={contactPersonInitialData}
            visible={contactPersonDrawerVisibility}
            title="Create Contact Person"
            okText={'Create'}
            onClose={() => setContactPersonDrawerVisibility(false)}
            onSubmit={async (values) => {
              createContactPerson(values, (success, error) => {
                if (error) {
                  setContactPersonDrawerVisibility(true)
                  toastMessage('Error occured.', 'error')
                } else {
                  setContactPersonDrawerVisibility(false)
                  toastMessage('Contact Person created.', 'success')
                }
              })
            }}
          />
        </Grid>
      </Grid>
      <ConfirmationDialog
        visibility={deleteConfirmationVisibility}
        title={'Delete Vendor Details'}
        message={`Do you want to delete details of Customer - ${vendorData?.name} ?`}
        okText="Delete"
        cancelText={'Cancel'}
        onCancel={() => {
          setDeleteConfirmationVisibility(false)
        }}
        onOk={() => {
          let values = _.cloneDeep(vendorData)
          values.id = values._id
          delete values._id
          delete values.business_id
          let contact = []
          for (let i = 0; i < values.contactperson.length; i++) {
            if (values.contactperson[i]?.business_id) {
              delete values.contactperson[i].business_id
            }
            contact.push(BigInt(values.contactperson[i]?._id))
          }
          delete values.contactperson
          values.contactperson = contact
          values.delete_status = true
          delete values.key
          updateVendor(values, (success, error) => {
            if (error) {
              setDeleteConfirmationVisibility(false)
              toastMessage('Unable to delete Vendor details', 'error')
            } else {
              let payload = {
                pageNumber: page,
                limit: limit
              }
              fetchVendor(payload)
              toastMessage('Vendor details deleted successfully', 'success')
              setDeleteConfirmationVisibility(false)
            }
          })
        }}
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}

export default Vendor
